import { useMemo } from 'react'
import {
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from 'react-router-dom'
import queryString from 'query-string'

const useRouter = () => {
  const params = useParams()
  const location = useLocation()
  const history = useHistory()
  const match = useRouteMatch()

  const data = useMemo(
    () => ({
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      search: location.search,
      query: {
        ...queryString.parse(location.search), // Convert string to object
        ...params,
      },
      match,
      location,
      history,
    }),
    [params, match, location, history]
  )

  return data
}

export default useRouter
